import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useUser } from '@/queries/useUser';
import { useAuthStore } from '@/stores/authStore';
import { useIntegrationErrors } from './useIntegrationErrors';

export interface SettingsTab {
    id: string;
    title: string;
    hasError?: boolean;
}

export const useSettingsNavigation = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') || 'profile';
    const { user } = useUser();
    const isAdminLoggedInAsUser = useAuthStore(state => state.isAdminLoggedInAsUser());
    const { hasProductWithErroredIntegration } = useIntegrationErrors();

    const isAffiliateOnlySubscription = user?.subscription_tier === 'affiliate';

    const tabs: SettingsTab[] = useMemo(
        () => [
            { id: 'profile', title: 'Profile' },
            ...(!isAffiliateOnlySubscription
                ? [{ id: 'integrations', title: 'Integrations', hasError: hasProductWithErroredIntegration }]
                : []),
            { id: 'billing', title: 'Billing' },
            { id: 'store', title: 'Payments' },
            ...(!isAffiliateOnlySubscription ? [{ id: 'communication', title: 'Email Notifications' }] : []),
            { id: 'security', title: 'Security' },
            ...(isAdminLoggedInAsUser ? [{ id: 'admin', title: 'Admin' }] : []),
        ],
        [isAffiliateOnlySubscription, isAdminLoggedInAsUser, hasProductWithErroredIntegration]
    );

    const handleTabChange = (tabId: string) => {
        setSearchParams({ tab: tabId });
    };

    return {
        activeTab,
        tabs,
        handleTabChange,
    };
};
